import { Box, Button, IconButton, Rating, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import axios from "axios";
import { API_URL } from "./Constant";
import PartyPopperEffect from "./PartyPopperEffect";
import ReferralSection from "../Pages/ReferAFreind";
import Colors from "./Colors";
import congrats from "../images/congrats.png";

const PlayPuzzleGridBackend = ({
  highlightedBox,
  onCellClick,
  questions,
  userAnswer,
  setHighlightedBox,
  setUserAnswer,
  setAllGridData,
  allGridData,
}) => {
  // console.log(allGridData)
  const [isWin, setIsWin] = useState(false);
  const [isRefer, setIsRefer] = useState(false);
  const [playerID, setPlayerId] = useState(null);

  const fetchGameScoreData = async () => {
    if (
      !localStorage.getItem("PlayerTocken") &&
      !localStorage.getItem("RapidGame") &&
      !localStorage.getItem("BackToBenchTocken") &&
      !localStorage.getItem("TimelessTiesTocken")
    ) {
      const ipResponse = await axios.get("https://api64.ipify.org?format=json");
      const userIP = ipResponse.data.ip;
      // console.log(userIP)
      // Send the IP address to your API
      try {
        const response = await axios.post(`${API_URL}/insert_player_count`, {
          ip_address: userIP,
        });
        //  console.log('Player score:', response.data);
      } catch (error) {
        console.error("Error fetching game score or IP address:", error);
      }
      return;
    } else if (!questions || questions.length === 0) {
      console.error("Error: Questions data is missing or empty.");
      return;
    } else if (
      localStorage.getItem("PlayerTocken") &&
      !localStorage.getItem("RapidGame") &&
      !localStorage.getItem("BackToBenchTocken") &&
      !localStorage.getItem("TimelessTiesTocken")
    ) {
      try {
        const response = await axios.post(`${API_URL}/insert_player_score`, {
          PlayerTocken: localStorage.getItem("PlayerTocken"),
          gameId: questions[0].game_id,
          creatorId: questions[0].creator_id,
          reducePount: localStorage.getItem("PointReduce"),
        });

        // console.log('Player score:', response.data);
      } catch (error) {
        console.error("Error fetching game score:", error);
      }
    } else if (
      localStorage.getItem("PlayerTocken") &&
      localStorage.getItem("RapidGame") &&
      !localStorage.getItem("BackToBenchTocken") &&
      !localStorage.getItem("TimelessTiesTocken")
    ) {
      const storedPublishingTime = localStorage.getItem("PublishingTime");
      const todaysDate = new Date().toISOString().split("T")[0];
      const storedDate = new Date(storedPublishingTime)
        .toISOString()
        .split("T")[0];
      if (todaysDate === storedDate) {
        try {
          const response = await axios.post(
            `${API_URL}/insert_player_score_rapid_game`,
            {
              PlayerTocken: localStorage.getItem("PlayerTocken"),
              category: localStorage.getItem("RapidGame"),
              gameId: localStorage.getItem("RapidGameId"),
            },
          );
        } catch (error) {
          console.error("Error fetching game score:", error);
        }
      } else {
        console.log("demo");
      }
    } else if (
      localStorage.getItem("BackToBenchTocken") &&
      !localStorage.getItem("TimelessTiesTocken")
    ) {
      try {
        const response = await axios.post(
          `${API_URL}/insert_player_score_back_to_bench_game`,
          {
            gameId: questions[0].game_id,
            creatorId: questions[0].creator_id,
            PlayerTocken: localStorage.getItem("BackToBenchTocken"),
          },
        );
        if (response.data.success === true) {
          localStorage.removeItem("BackToBenchTocken");
        }

        //  console.log('Player score:', response.data);
      } catch (error) {
        console.error("Error fetching game score:", error);
      }
    }
  };

  useEffect(() => {
    console.log(userAnswer);
    if (highlightedBox && userAnswer) {
      const updatedGrid = updateGridWithUserAnswer();
      //  console.log('updatedGrid',updatedGrid)
      setAllGridData(updatedGrid);
      const timer = setTimeout(() => {
        incrementQuestionNumber(highlightedBox.question_number);
      }, 1000);
      return () => clearTimeout(timer);
    }
    // console.log(allGridData)
  }, [userAnswer, highlightedBox]);

  useEffect(() => {
    if (highlightedBox && userAnswer) {
      const unansweredQuestions = questions.filter((q) => {
        const questionNumber = q.question_number;
        const questionInGrid = findCellForQuestion(questionNumber);
        if (questionInGrid) {
          const { row, col } = questionInGrid;
          const cell = allGridData[row][col];
          return cell.answer === ""; // If the answer is empty, it is unanswered
        }
        return false;
      });
      const notansweredQuestions = questions
        .filter((q) => !isQuestionAnswered(q.question_number))
        .map((q) => q.question_number)
        .sort((a, b) => a - b);
      //console.log('unansweredQuestions.length',notansweredQuestions.length)
      // Sort unanswered questions by question number (ascending)
      if (notansweredQuestions.length === 0) {
        setIsWin(true);
        fetchGameScoreData();
      }
    }
  }, [userAnswer, highlightedBox, allGridData]);

  const updateGridWithUserAnswer = () => {
    // Deep copy of the grid
    const updatedGrid = allGridData.map((row) =>
      row.map((cell) => ({ ...cell })),
    );

    if (!highlightedBox || !userAnswer) return updatedGrid;

    const answerLetters = Array.isArray(userAnswer)
      ? userAnswer
      : typeof userAnswer === "string"
        ? userAnswer.split(",")
        : [];

    const { direction, question_number } = highlightedBox;

    let currentRow, currentCol;

    // Locate the starting position for the highlighted question
    let found = false;
    for (let r = 0; r < updatedGrid.length && !found; r++) {
      for (let c = 0; c < updatedGrid[r].length; c++) {
        if (updatedGrid[r][c].value === String(question_number)) {
          currentRow = r;
          currentCol = c;
          found = true;
          break;
        }
      }
    }

    if (!found) return updatedGrid; // If starting position not found, return grid as is

    // Update grid with answer letters
    for (const letter of answerLetters) {
      // Ensure we're within bounds
      if (
        currentRow < updatedGrid.length &&
        currentCol < updatedGrid[currentRow]?.length
      ) {
        const cell = updatedGrid[currentRow][currentCol];

        // Update the cell's answer
        cell.answer = letter;

        // Move to the next cell in the specified direction
        if (direction === "across") currentCol++;
        else if (direction === "down") currentRow++;
      }
    }

    return updatedGrid;
  };

  const incrementQuestionNumber = (currentQuestionNumber) => {
    const questionNumbers = questions.map((q) => q.question_number);
    const maxQuestionNumber = Math.max(...questionNumbers);
    const minQuestionNumber = Math.min(...questionNumbers);

    const findNextUnansweredQuestion = () => {
      // Find all unanswered questions sorted by question number
      const unansweredQuestions = questions
        .filter((q) => !isQuestionAnswered(q.question_number))
        .map((q) => q.question_number)
        .sort((a, b) => a - b);

      if (unansweredQuestions.length === 0) {
        setIsWin(true);
        fetchGameScoreData();
        return null; // No unanswered questions remain
      }

      // If at the last question, start from the least unanswered question
      if (currentQuestionNumber === maxQuestionNumber) {
        // console.log("Currently on the last question. Starting with least unanswered question.");
        return unansweredQuestions[0];
      }

      // Otherwise, find the next unanswered question after the current one
      return (
        unansweredQuestions.find((num) => num > currentQuestionNumber) ||
        unansweredQuestions[0]
      );
    };

    const nextQuestionNumber = findNextUnansweredQuestion();

    if (nextQuestionNumber === null) {
      // console.log("All questions are answered, game completed!");
      setIsWin(true);
      fetchGameScoreData();
      return;
    }

    // console.log("Next Question Number:", nextQuestionNumber);

    // Reset the highlighted box and user input
    setHighlightedBox({
      question_number: "",
      direction: "",
      question_text: "",
      answer: "",
      length: "",
      attachment: "",
      answer_options: "",
    });
    setUserAnswer("");

    // Find and navigate to the next question
    const nextQuestion = questions.find(
      (q) => q.question_number === nextQuestionNumber,
    );

    if (nextQuestion) {
      const {
        question_number,
        direction,
        question_text,
        answer,
        length,
        attachment,
        answer_options,
      } = nextQuestion;

      const found = findCellForQuestion(nextQuestionNumber);
      if (found) {
        onCellClick({
          question_number,
          direction,
          question_text,
          answer,
          length,
          attachment,
          answer_options,
        });
      }
    }
  };

  const isQuestionAnswered = (questionNumber) => {
    for (let row = 0; row < allGridData.length; row++) {
      for (let col = 0; col < allGridData[row].length; col++) {
        const cell = allGridData[row][col];
        if (cell.value === String(questionNumber)) {
          // Check both visibility and the answer property
          return cell.answer && cell.answer.trim() !== "";
        }
      }
    }
    return false; // Return false if no matching question number or answer found
  };

  const findCellForQuestion = (questionNumber) => {
    for (let r = 0; r < allGridData.length; r++) {
      for (let c = 0; c < allGridData[r].length; c++) {
        if (allGridData[r][c].value === String(questionNumber)) {
          return { row: r, col: c };
        }
      }
    }
    return null;
  };

  const handleCellClick = (rowIndex, cellIndex, cellValue) => {
    //  console.log(rowIndex, cellIndex);

    // Clear previous highlights
    setHighlightedBox((prevState) => ({
      ...prevState,
      question_number: "",
      direction: "",
      question_text: "",
      answer: "",
      length: "",
      attachment: "",
      answer_options: "",
    }));
    setUserAnswer("");

    // Check if clicked cell has a value (i.e., a valid question number)
    if (cellValue && cellValue.trim() !== "") {
      // Find the question that matches the cell value (matching by question number)
      const questionForValue = questions?.find(
        (q) => q.question_number.toString() === cellValue.trim(),
      );

      //  console.log('Question for Value:', questionForValue);

      // If question found, pass it to onCellClick
      if (questionForValue) {
        onCellClick({
          question_number: questionForValue.question_number,
          direction: questionForValue.direction,
          question_text: questionForValue.question_text,
          answer: questionForValue.answer,
          length: questionForValue.length,
          attachment: questionForValue.attachment,
          answer_options: questionForValue.answer_options,
        });
        return; // Stop further execution if a question was found
      }
    } else {
      const questionForValue = findCellForQuestionByAnswer(rowIndex, cellIndex);
      if (questionForValue) {
        onCellClick({
          question_number: questionForValue.question_number,
          direction: questionForValue.direction,
          question_text: questionForValue.question_text,
          answer: questionForValue.answer,
          length: questionForValue.length,
          attachment: questionForValue.attachment,
          answer_options: questionForValue.answer_options,
        });
        return;
      }
    }
    // Otherwise, find the first matching question for the cell (if no value)
    const question = questions?.find(
      (q) => q.row_index === rowIndex && q.col_index === cellIndex,
    );

    //console.log('Fallback Question:', question);

    if (question) {
      onCellClick({
        question_number: question.question_number,
        direction: question.direction,
        question_text: question.question_text,
        answer: question.answer,
        length: question.length,
        attachment: question.attachment,
        answer_options: question.answer_options,
      });
    }
  };

  const handleClose = async () => {
    setIsWin(false); // Reset the game state
    if (window.location.pathname === "/play-game" || "/rapid-riddle-game") {
      window.location.href = "/";
    } else {
      setIsWin(false);
    }
  };
  const findCellForQuestionByAnswer = (rowIndex, cellIndex) => {
    return questions?.find((q) => {
      const startRow = q.row_index;
      const startCol = q.col_index;
      const length = q.length;

      if (q.direction === "across") {
        return (
          rowIndex === startRow &&
          cellIndex >= startCol &&
          cellIndex < startCol + length
        );
      } else if (q.direction === "down") {
        return (
          cellIndex === startCol &&
          rowIndex >= startRow &&
          rowIndex < startRow + length
        );
      }
      return false;
    });
  };

  const renderGrid = () => {
    return allGridData.map((row, rowIndex) => (
      <tr key={rowIndex}>
        {row.map((cell, cellIndex) => (
          <td
            key={cellIndex}
            className={`grid-cell ${cell.visible ? "visible" : "hidden"} ${
              highlightedBox &&
              highlightedBox.row === rowIndex &&
              highlightedBox.col === cellIndex
                ? "active"
                : ""
            }`}
            onClick={() =>
              handleCellClick(rowIndex, cellIndex, cell.value || "")
            }
          >
            {cell.visible && (
              <div>
                {cell.value && <span className="cell-value">{cell.value}</span>}
                {cell.answer && (
                  <span className="cell-answer">{cell.answer}</span>
                )}
              </div>
            )}
          </td>
        ))}
      </tr>
    ));
  };

  return (
    <div>
      <table className="crossword-grid">
        <tbody>{renderGrid()}</tbody>
        {isWin && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: "1000",
            }}
          >
            <PartyPopperEffect></PartyPopperEffect>
            <Box
              sx={{
                width: { md: "25%", sm: "35%", xs: "75%" },
                background: Colors.Tidesbg,
                borderRadius: "8px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "16px",
                border: "0px solid white",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <IconButton
                  onClick={() => handleClose()}
                  sx={{
                    color: Colors.signupBorder,
                    fontWeight: 600,
                    "&:hover": {
                      color: "#000000",
                    },
                  }}
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </Box>

              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: { md: "38px", xs: "32px" },
                  color: "#000",
                  textAlign: "center",
                  mb: 2,
                  fontFamily: "'Dancing Script', cursive", // Calligraphy-style font
                }}
              >
                Congratulations! 🎉
              </Typography>

              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  color: Colors.button1Border,
                  textAlign: "center",
                }}
              >
                You have successfully completed the snow word puzzle. Great
                job!!
              </Typography>

              <Box
                sx={{
                  marginTop: "24px",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              ></Box>
            </Box>
          </Box>
        )}
        {isRefer && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: "1000",
            }}
          >
            <Box
              sx={{
                width: { md: "25%", sm: "35%", xs: "75%" },
                background: "#F1F3FC",
                borderRadius: "8px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "24px",
                border: "3px solid white",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                  mb: 2,
                }}
              >
                <IconButton
                  onClick={() => {
                    setIsRefer(false);
                    window.history.back();
                  }}
                  sx={{
                    color: "#6b6b6b",
                    "&:hover": {
                      color: "#000000",
                    },
                  }}
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </Box>

              <ReferralSection></ReferralSection>

              <Box
                sx={{
                  marginTop: "24px",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              ></Box>
            </Box>
          </Box>
        )}
      </table>

      <style jsx>{`
        .crossword-grid {
          margin-top: 16px;
          border-collapse: collapse;
        }

        .grid-cell {
          border: 2px solid #000;
          width: 48px;
          height: 48px;
          position: relative;
          text-align: center;
          vertical-align: middle;
          font-size: 14px;
          background-color: #fff;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .grid-cell.hidden {
          background-color: ${Colors.gamebg}; /* Hidden cells are white */
          border: none;
        }

        .grid-cell.visible {
          background-color: #f8f8ff; /* Light color for visible cells */
        }

        .grid-cell.visible.active {
          background-color: ${Colors.gamebg}; /* Active cells are light blue */
        }

        .grid-cell.visible:hover {
          background-color: ${Colors.gamebg}; /* blue hover effect for active cells */
        }

        .cell-value {
          position: absolute;
          top: 5%;
          left: 5%;
          font-size: 10px;
          color: #000;
        }

        .cell-answer {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 14px;
          color: #000;
          font-weight: bold;
        }

        /* Responsive design for the modal */
        @media screen and (max-width: 600px) {
          .grid-cell {
            width: 40px;
            height: 40px;
          }
        }
      `}</style>
    </div>
  );
};

export default PlayPuzzleGridBackend;
